var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-select",
    {
      class: {
        "v-select-danger": _vm.invalid === false,
        "select-size-sm": _vm.small
      },
      attrs: {
        value: _vm.value,
        name: _vm.name,
        options: _vm.paginatedValues,
        disabled: _vm.isDisabled,
        placeholder: _vm.computedPlaceholder,
        selectable: function(opt) {
          return !opt.disabled
        },
        reduce: function(opt) {
          return opt.value
        },
        "close-on-select": !_vm.multiple,
        clearable: _vm.clearable,
        taggable: _vm.taggable,
        searchable: _vm.searchable,
        filterable: _vm.filterable,
        multiple: _vm.multiple
      },
      on: {
        search: _vm.onSearch,
        "click:clear": _vm.handleClearClick,
        "option:selecting": _vm.handleSelecting,
        "search:focus": _vm.onFocus,
        input: _vm.onInput
      },
      scopedSlots: _vm._u([
        {
          key: "spinner",
          fn: function() {
            return [
              _vm.isLoading
                ? _c("b-spinner", { attrs: { variant: "primary", small: "" } })
                : _vm._e()
            ]
          },
          proxy: true
        },
        {
          key: "no-options",
          fn: function() {
            return [_vm._v(" Escribe para buscar opciones ")]
          },
          proxy: true
        }
      ])
    },
    [
      _vm.hasNextPage
        ? _c(
            "li",
            {
              staticClass: "pagination",
              attrs: { slot: "list-footer" },
              slot: "list-footer"
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-block btn-primary btn-sm",
                  attrs: { type: "button", disabled: !_vm.hasNextPage },
                  on: { click: _vm.searchPage }
                },
                [_vm._v(" buscar mas opciones... ")]
              )
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }